"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireDefault(require("react"));
var _definitions = require("@ppay/definitions");
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _Actions = require("./Actions");
var _data = require("../data");
var _utils = require("../../../../utils");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TableData = (0, _styledComponents.default)(_ui.TableData)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 66px;\n"])));
var MinWidthTableData = (0, _styledComponents.default)(TableData)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), _utils.mediaQuery.greaterThan('xl')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    min-width: 200px;\n  "]))));
var Table = function Table(_ref) {
  var balances = _ref.balances,
    _onDepositClick = _ref.onDepositClick,
    _onSendClick = _ref.onSendClick,
    onHistoryClick = _ref.onHistoryClick;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libWallets', 'libCommon']),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Table, null, /*#__PURE__*/_react.default.createElement(_ui.TableHead, null, /*#__PURE__*/_react.default.createElement(_ui.TableRow, null, /*#__PURE__*/_react.default.createElement(_ui.TableHeader, null, t('assets')), /*#__PURE__*/_react.default.createElement(_ui.TableHeader, null, t('libCommon:balance')), /*#__PURE__*/_react.default.createElement(_ui.TableHeader, null, t('libCommon:actions')))), /*#__PURE__*/_react.default.createElement(_ui.TableBody, null, balances.map(function (b) {
    return /*#__PURE__*/_react.default.createElement(_ui.TableRow, {
      key: b.ticker
    }, /*#__PURE__*/_react.default.createElement(MinWidthTableData, null, /*#__PURE__*/_react.default.createElement(_data.DataAssets, {
      ticker: b.ticker
    })), /*#__PURE__*/_react.default.createElement(MinWidthTableData, null, /*#__PURE__*/_react.default.createElement(_ui.AmountTableData, {
      value: b.value,
      ticker: b.ticker,
      convertedValue: b.converted,
      convertedTicker: _definitions.Ticker.USD
    })), /*#__PURE__*/_react.default.createElement(TableData, null, /*#__PURE__*/_react.default.createElement(_Actions.Actions, {
      onDepositClick: function onDepositClick() {
        return _onDepositClick(b.ticker);
      },
      onSendClick: function onSendClick() {
        return _onSendClick(b.ticker);
      },
      onHistoryClick: onHistoryClick,
      className: "me-2",
      ticker: b.ticker
    })));
  })));
};
exports.Table = Table;